module.exports = __webpack_public_path__ + "static/img/200185.29ff07f8.png";